module.exports = __webpack_public_path__ + "img/spartan-masonry-concrete-tile-05-xxlarge.7fd035ee.jpg";